import { Error as ErrorIcon } from '@mui/icons-material';
import { Alert } from '@mui/material';
import React from 'react';
import { CustomIconWrapper, Loader } from '../../components/loaders/Loader';
import { Spinner } from '../../components/loaders/Spinner';

export type LoaderData = React.ReactNode | LoaderWithIcon;

type LoaderWithIcon = {
  readonly message: React.ReactNode;
  readonly icon?: React.ReactNode;
};

function isComplexMessage(d: LoaderData): d is LoaderWithIcon {
  return !!(d && typeof (d as any).message !== 'undefined');
}

export function ViewLoader(p: { loaderData?: LoaderData }) {
  const { loaderData } = p;

  const message = isComplexMessage(loaderData) ? loaderData.message : loaderData;

  const icon =
    isComplexMessage(loaderData) && loaderData.icon ? (
      <CustomIconWrapper>{loaderData.icon}</CustomIconWrapper>
    ) : (
      <Spinner />
    );

  return <Loader message={message} icon={icon} />;
}

export function ViewError(p: { error: Error }) {
  console.log(p.error);

  return (
    <Alert severity="error" icon={<ErrorIcon />}>
      {p.error.message}
    </Alert>
  );
}
